export function getDropdownOptionState(
	isSelected: boolean,
	isHighlighted: boolean,
) {
	return isHighlighted ? 'highlighted' : isSelected ? 'selected' : 'default';
}
